import './index.scss';

import { Component, createRef, ReactNode, ContextType } from 'react';
import { createPortal } from 'react-dom';

import t from 'utils/i18n';
import { BraxThemeVariant } from '../../types';
import ToastsContext from '../BraxToasts/context';
import { BraxButton } from '../BraxButton';
import { BraxIcon } from '../BraxIcon';

export type BraxToastProps = {
    className: string,
    timer?: number | null,
    type: Extract<BraxThemeVariant, 'primary' | 'success' | 'destructive'>,
    title: ReactNode,
    description: ReactNode,
    action?: ReactNode,
    onClick?: () => void,
    onAction?: () => void,
    onDismiss?: () => void
};

type BraxToastState = {
    animationState: 'in' | 'out' | null
};

export class BraxToast extends Component<BraxToastProps, BraxToastState> {

    static defaultProps = {
        className: ''
    };

    static contextType = ToastsContext;

    declare context: ContextType<typeof ToastsContext>

    ref = createRef<HTMLDivElement>();

    state: BraxToastState = {
        animationState: null
    };

    timeout: any = null;

    componentDidMount() {
        const timer: number | null = this.props.timer !== undefined
            ? this.props.timer
        : this.props.type === 'destructive'
            ? null
            : 15;

        if (this.timeout === null && timer !== null)
            this.timeout = setTimeout(() => this.dismiss(), timer * 1000);
    }

    dismiss() {
        if (this.timeout !== null) {
            clearTimeout(this.timeout);

            this.timeout = null;
        }

        this.setState({ animationState: 'out' });

        setTimeout(() => {
            if (this.props.onDismiss)
                this.props.onDismiss();
        }, 1000);
    }

    callAction() {
        this.dismiss();

        if (this.props.onAction)
            this.props.onAction();
    }

    getContainerHeight() {
        return this.ref.current
            ? this.ref.current.clientHeight + (window.innerWidth > 350 ? 16 : 8)
            : 0;
    }

    render() {
        const container = 'type' in this.props && this.props.type === 'destructive' ? this.context.left.current : this.context.right.current;

        if (!container) {
            setTimeout(() => this.forceUpdate(), 500);

            return null;
        }

        if (this.state.animationState === null)
            setTimeout(() => this.setState({ animationState: 'in' }), 250);

        return createPortal(
            <div
                ref={this.ref}
                className={`brax-toast ${this.props.type} ${this.state.animationState || ''} ${this.props.className}`}
                style={{
                    marginBottom: this.state.animationState === 'out' ? `-${this.getContainerHeight()}px` : undefined,
                    cursor: this.props.onClick ? 'pointer' : undefined
                }}
                onClick={this.props.onClick}
            >
                <div>
                    <BraxIcon icon={this.props.type === 'success' ? 'check-rounded' : 'exclamation-mark'} />

                    <div>
                        <p>{ this.props.title }</p>

                        { typeof this.props.description === 'object' ? (
                            this.props.description
                        ) : (
                            <p>{ this.props.description }</p>
                        ) }
                    </div>
                </div>

                <BraxButton variant={this.props.type === 'primary' ? 'secondary' : 'light'} onClick={() => this.callAction()}>
                    { this.props.action || t('Entendido') }
                </BraxButton>
            </div>,
            container
        );
    }

}
